// Status pill. Plan 24. Replaces the `<span class="bg-amber-50 ..."` +
// `<span class="bg-green-50 ..."` sprinkled through dashboards.

import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../utils/cn';

export type BadgeVariant = 'neutral' | 'success' | 'warning' | 'danger' | 'info';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
  children: ReactNode;
}

const VARIANT_CLASSES: Record<BadgeVariant, string> = {
  neutral: 'bg-stone-100 text-stone-600 border-stone-200',
  success: 'bg-green-50 text-green-700 border-green-100',
  warning: 'bg-amber-50 text-amber-700 border-amber-100',
  danger: 'bg-red-50 text-red-700 border-red-100',
  info: 'bg-stone-50 text-stone-700 border-stone-200',
};

export const Badge = ({ variant = 'neutral', className, children, ...rest }: BadgeProps) => (
  <span
    className={cn(
      'inline-flex items-center gap-1 px-3 py-1 rounded-full border text-[10px] font-bold uppercase tracking-widest',
      VARIANT_CLASSES[variant],
      className
    )}
    {...rest}
  >
    {children}
  </span>
);
